import { render } from "./shippingSoftware.vue?vue&type=template&id=144ae8bb"
import script from "./shippingSoftware.vue?vue&type=script&lang=js"
export * from "./shippingSoftware.vue?vue&type=script&lang=js"

import "./shippingSoftware.vue?vue&type=style&index=0&id=144ae8bb&lang=css"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__